import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex).attrs({
  mt: ['-80px', '-188px'],
})`
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  color: ${themeGet('colors.white')};
  min-height: 268px;
`

export const Content = styled(Flex).attrs({
  ml: [0, 0, 0, 13],
  mt: [5, 5, 5, 0],
  p: [5, 13],
})`
  width: 100%;
  min-height: 268px;
  flex-direction: column;
  flex-grow: 1;
  align-items: flex-start;
  border-radius: 40px;
  box-shadow: 4px 8px 32px 0 rgba(0, 0, 0, 0.1);
  background-color: ${themeGet('colors.white')};
`

export const ImageHolder = styled(Flex).attrs({
  p: [32, 32, 32, 48],
})`
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  height: 268px;
  width: 268px;
  min-width: 268px !important;
  border-radius: 40px;
  box-shadow: 4px 8px 32px 0 rgba(0, 0, 0, 0.1);
  background-color: ${themeGet('colors.white')};

  img,
  div {
    max-height: 200px;
    width: 100%;
    object-fit: contain;
  }
  @media screen and (max-width: ${themeGet('breakpoints.2')}) {
    max-height: 80%;
    width: 100%;
  }
`
export const Dash = styled.div`
  margin: 20px 0 24px;
  width: 48px;
  height: 4px;
  min-height: 4px;
  border-radius: 2px;
  background-color: ${themeGet('colors.bg.light')};
`
